module.exports = __webpack_public_path__ + "static/media/readersdigest.7d6d4ac4.png";